import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="container prose-page">
      <p className="eyebrow">404 · Sidan saknas</p>
      <h1>Här var det tomt.</h1>
      <p>Sidan kan ha flyttats eller så har länken blivit fel. Gå till startsidan eller kontakta oss så hjälper vi dig.</p>
      <div style={{display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 28}}>
        <Link to="/" className="button button-primary">Till startsidan</Link>
        <Link to="/kontakt" className="button button-secondary">Kontakta oss</Link>
      </div>
    </section>
  );
}
